import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react'

const PeriodLayout = (props) => (
    <>
    <Placeholder name="main-layout" rendering={props.rendering} itemid={props.itemidkey} />
    </>
);

export default PeriodLayout;
